import { render, staticRenderFns } from "./AuthLogoutRedirectPage.vue?vue&type=template&id=cddeffb2&scoped=true"
import script from "./AuthLogoutRedirectPage.vue?vue&type=script&lang=ts"
export * from "./AuthLogoutRedirectPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddeffb2",
  null
  
)

export default component.exports